import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

// Which of a learner's names a report shows. Unspecified marks a template
// saved before the formats existed.
export default BaseEnum.create({
  values: [
    { value: 0, label: 'Unspecified' },
    { value: 1, label: 'Preferred' },
    { value: 2, label: 'Legal' },
  ],
});
